import { render } from "./ProductImagesComponent.vue?vue&type=template&id=21184013"
import script from "./ProductImagesComponent.vue?vue&type=script&lang=js"
export * from "./ProductImagesComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__